import React, { useState, useEffect } from "react";
import {
  manualCheck,
  fetchFile,
  fetchProcessData,
  getAllProductName
} from "../../../Services/DataServices";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment";
import GenericTable from "./GenericTable";
import Loader from "../../../Components/Common/Loader";
import { Button, Dropdown } from "react-bootstrap";
import { FaPlay } from "react-icons/fa";

const CurateProductCont = () => {
  const [product, setProduct] = useState("");
  const [curatedData, setCuratedData] = useState("");
  const [curatedGroup, setCuratedGroup] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [productData, setProductData] = useState({PRODUCT: "", industry: "FORMULATIONS"});

  const paginationPerPage = 50;

  const manualCheckData = async (event) => {
    event.preventDefault(); // Prevent page reload
    if (productData.PRODUCT.trim() === "") {
      toast.error("Please enter a product name.");
      return;
    }
    try {
      const user = localStorage.getItem("user")
      const parseUser = JSON.parse(user)
      const data = {
        ...productData,
        userId: parseUser?.userId,
      }
      const response = await manualCheck(data); // Sending { product 
      if (response?.data?.PRODUCT) {
        setCuratedData(response.data);
        setCuratedGroup(response.data.productGroup);
        fetchData();
      } else {
        toast.error("Curation failed. Please try again.");
      }
    } catch (error) {
      toast.error("Error fetching curated data.");
      console.error("Curation Error:", error);
    }
  };
  const fetchData = async (page = 1) => {
    setLoading(true);
    const {status, result } = await getAllProductName( page, paginationPerPage);
    setData(result?.result);
    setTotalPages(result?.pagination.totalPages);
    setTotalCount(result?.pagination.total)
    setTimeout(() => {
      setLoading(false)
    }, 100);
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);


  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleProductChange = (name, value) => {
    setProductData(prev => ({ ...prev, [name]: value }));
  };

  const columnList = [
    {
      label: "Date",
      field: "createdAt",
      cell: (row) => (
        <span>
          {moment(row.createdAt).format("hh:mm A, DD/MM/YYYY ")}
        </span>
      ),
    },
    {
      label: "Product Name",
      field: "productName",
    },
    // {
    //   label: "Product Group",
    //   field: "productGroup",
    //   cell: (row) => (
    //     <span>
    //       {row.productGroup ? row.productGroup : "-"}
    //     </span>
    //   ),
    // },
    {
      label: "Unique Product Name",
      field: "uniqueProductName",
      cell: (row) => (
        <span>
          {row.uniqueProductName ? row.uniqueProductName : "-"}
        </span>
      ),
    },
    {
      label: "Curated Product Name",
      field: "curatedProductName",
    },
    {
      label: "Verification",
      field: "verified",
    },
    {
      label: "User",
      field: "",
      cell: (row) =>
        <div>{row?.user?.firstName}</div>
    }
  ];
  <br />


  return (
    <div>
      <div style={{ display: "flex", marginBottom: "1%" }}>
        <form onSubmit={manualCheckData} style={{ width: "100%" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <textarea
              placeholder="Enter Product Name To Curate..."
              value={productData.PRODUCT}
              name="PRODUCT"
              style={{ width: "100%", height: "80px", resize: "vertical", marginRight: 20, padding: 10, fontSize: 15, borderRadius: 10 }}
              onChange={(e) => handleProductChange("PRODUCT",e.target.value)}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic" style={{ padding: 7, margin: "10px" , backgroundColor: "#4b38b3", marginTop: 10, display: "block", paddingRight: 20, paddingLeft: 20, fontSize: 15  }}>
              {productData.industry || 'Select Industry'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleProductChange("industry", 'CH28')}>CH-28</Dropdown.Item>
              <Dropdown.Item onClick={() => handleProductChange("industry", 'PHARMACUATICALS')}>CH-29</Dropdown.Item>
              <Dropdown.Item onClick={() => handleProductChange("industry", 'FORMULATIONS')}>CH-30</Dropdown.Item>
              <Dropdown.Item onClick={() => handleProductChange("industry", 'XIPIENTS')}>CH-Excipients</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Button
            type="submit"
            style={{ padding: 7, margin: "10px" , backgroundColor: "#4b38b3", marginTop: 10, display: "block", paddingRight: 20, paddingLeft: 20, fontSize: 15 }}
          >
            <FaPlay style={{marginRight: 10}} />
            Curate Data
          </Button>
          </div>
          {curatedData && (
            <div style={{
              marginTop: '25px',
              padding: '0',
              backgroundColor: 'white',
              borderRadius: '8px',
              border: '2px solid #e2e8f0',
              overflow: 'hidden'
            }}>
              {/* Row 1: Curated Product */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '280px 1fr',
                borderBottom: '1px solid #e2e8f0'
              }}>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Curated Product
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5'
                }}>
                  {curatedData?.curatedPRODUCT?.toUpperCase() || '-'}
                </div>
              </div>

              {/* Row 2: Actual Product */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '280px 1fr',
                borderBottom: '1px solid #e2e8f0'
              }}>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Curation name
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5'
                }}>
                  {curatedData?.productName?.toUpperCase() || '-'}
                </div>
              </div>

              {/* Row 2: Actual Product */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '280px 1fr',
                borderBottom: '1px solid #e2e8f0'
              }}>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Actual Product
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5'
                }}>
                  {curatedData?.PRODUCT?.toUpperCase() || '-'}
                </div>
              </div>

              {/* Row 3: Unique Product Name (Col1) and Code (Col2) */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '280px 1fr 280px 1fr',
                borderBottom: '1px solid #e2e8f0'
              }}>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Unique Product Name
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  {curatedData?.uniqueProductName?.toUpperCase() || '-'}
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Product Group
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5'
                }}>
                  {curatedData?.productGroup?.toUpperCase() || '-'}
                </div>
              </div>

              {/* Row 4: Product Group (Col1) and Verification (Col2) */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '280px 1fr 280px 1fr',
                borderBottom: '1px solid #e2e8f0'
              }}>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Code
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  {curatedData?.casNo?.toUpperCase() || '-'}
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Verification
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5'
                }}>
                  {curatedData?.verified?.toUpperCase() || '-'}
                </div>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: '280px 1fr 280px 1fr',
                borderBottom: '1px solid #e2e8f0'
              }}>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Verification
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  {curatedData?.verified?.toUpperCase() || '-'}
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Fix Method
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5'
                }}>
                  {curatedData?.fixMethod?.toUpperCase() || '-'}
                </div>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: '280px 1fr 280px 1fr',
                borderBottom: '1px solid #e2e8f0'
              }}>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Meta upn
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  {curatedData?.meta?.uniqueProductName?.toUpperCase() || '-'}
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Meta Code
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5'
                }}>
                  {curatedData?.meta?.casNo?.toUpperCase() || '-'}
                </div>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: '280px 1fr 280px 1fr',
                borderBottom: '1px solid #e2e8f0'
              }}>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  PRODUCT type
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  {curatedData?.api_intermediate?.toUpperCase() || '-'}
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: '#f7fafc',
                  color: '#2d3748',
                  fontWeight: '700',
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderRight: '2px solid #e2e8f0'
                }}>
                  Meta Code
                </div>
                <div style={{
                  padding: '16px 20px',
                  backgroundColor: 'white',
                  color: '#1a202c',
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '1.5'
                }}>
                  {curatedData?.main_category?.toUpperCase() || '-'}
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
      {loading  ? <Loader/> : (
        <GenericTable
        {...{
          columnList,
          data,
          handlePageChange,
          totalPages,
          currentPage,
          totalCount,
          paginationPerPage : 50
        }} />
      )}
    </div>
  );
};
export default CurateProductCont;
